import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  Grid,
  List,
  ListItem,
  ListItemText,
  MuiThemeProvider,
  Typography
} from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import SelectTheme from 'components/Shared/SelectTheme';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { enTheme, IThemeCustomizer } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import * as rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';

import CustomizerOptionForm from './CustomizerOptionForm';

interface IProps {
  classes?: any;
}

interface IState {
  theme: IThemeCustomizer;
  selectedOption: number;
  openChangeThemeDialog: boolean;
  selectedTheme: enTheme;
}

@WithStyles(theme => ({
  drawerPaper: {
    position: 'relative',
    width: '100%',
    backgroundColor: '#FFF',
    top: 0
  },
  arrow: {
    fontSize: 10,
    color: theme.variables.colors['text']
  },
  listItem: {
    padding: '4px 24px',
    borderLeft: '8px solid #FFF'
  },
  listItemSelected: {
    borderLeftColor: '#FABB0A'
  },
  listItemIcon: {
    width: 60,
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      display: 'block',
      width: '100%'
    }
  },
  selectedTheme: {
    padding: theme.spacing.unit * 3
  },
  selectedThemeIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  changeThemeGrid: {
    paddingLeft: theme.spacing.unit
  },
  changeTheme: {
    color: theme.variables.colors['link'],
    textDecoration: 'underline',
    cursor: 'pointer'
  },
  optionForm: {
    position: 'absolute',
    left: 280,
    height: 400,
    width: 320,
    marginTop: 8,
    zIndex: 1,
    padding: theme.spacing.unit * 2
  },
  dialogActions: {
    justifyContent: 'center'
  },
  applyTheme: {
    backgroundColor: theme.variables.colors['success'],
    textTransform: 'none',
    color: '#FFF',
    padding: '8px 40px',
    fontWeight: 'bold',
    letterSpacing: 0.5,
    fontSize: 16,
    '&:hover': {
      backgroundColor: theme.variables.colors['successHover']
    }
  },
  dialog: {
    padding: '0 70px 24px 70px'
  },
  dialogTitle: {
    padding: '16px 24px 42px'
  }
}))
export default class CustomizerDrawer extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      selectedOption: null,
      theme: null,
      openChangeThemeDialog: false,
      selectedTheme: null
    };
  }

  componentDidMount() {
    themeCustomizerService
      .getThemeParameters()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(theme => {
        this.setState(oldState => {
          return { ...oldState, theme, selectedTheme: theme.id };
        });
      });

    themeCustomizerService
      .shouldOpenForm()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(shouldOpenForm => {
        if (!shouldOpenForm) {
          this.setState(oldState => {
            return { ...oldState, selectedOption: null };
          });
        }
      });
  }

  onChangeTheme = (themeId: enTheme) => {
    this.setState(oldState => {
      return { ...oldState, selectedTheme: themeId };
    });
  };

  openChangeThemeDialog = () => {
    this.setState(oldState => {
      return { ...oldState, openChangeThemeDialog: true };
    });
  };

  closeChangeThemeDialog = () => {
    this.setState(oldState => {
      return { ...oldState, openChangeThemeDialog: false };
    });
  };

  applyChangeTheme = () => {
    themeCustomizerService.setTheme(this.state.selectedTheme);
    this.closeChangeThemeDialog();
  };

  selectOption = (selectedOption: number) => {
    this.setState(oldState => {
      return { ...oldState, selectedOption };
    });

    themeCustomizerService.setSelectedOption(selectedOption);
    themeCustomizerService.openForm();
  };

  render() {
    const { classes } = this.props;
    const { selectedOption, theme, openChangeThemeDialog } = this.state;

    if (!theme) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <CustomizerOptionForm />
        <Dialog
          open={openChangeThemeDialog}
          onClose={this.closeChangeThemeDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <div className={classes.dialog}>
            <DialogTitle id="alert-dialog-title" disableTypography className={classes.dialogTitle}>
              Escolha um tema
            </DialogTitle>
            <DialogContent>
              <SelectTheme changeType={this.onChangeTheme} selectedTheme={theme.id} />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={this.applyChangeTheme} className={classes.applyTheme} variant="contained">
                Continuar
              </Button>
            </DialogActions>
          </div>
        </Dialog>
        <Drawer
          variant="permanent"
          classes={{
            paper: classes.drawerPaper
          }}
        >
          <List style={{ top: 0 }}>
            <Grid container className={classes.selectedTheme}>
              <Grid item xs={5} className={classes.selectedThemeIcon}>
                <SvgIcon name={theme.icon} />
              </Grid>
              <Grid item xs={7} className={classes.changeThemeGrid}>
                <Typography variant="subtitle1">{theme.name}</Typography>
                <a className={classes.changeTheme} onClick={this.openChangeThemeDialog}>
                  Trocar template
                </a>
              </Grid>
            </Grid>
            <Divider />
            {theme.options.map((option: any, key: number) => {
              return (
                // tslint:disable-next-line:max-line-length
                <ListItem
                  key={key}
                  button
                  divider
                  className={`${classes.listItem} ${selectedOption === key ? classes.listItemSelected : ''}`}
                  onClick={this.selectOption.bind(this, key)}
                >
                  {/* tslint:disable-next-line:max-line-length */}
                  <div className={classes.listItemIcon}>
                    <SvgIcon name={option.icon} />
                  </div>
                  <ListItemText
                    inset
                    primary={option.title}
                    primaryTypographyProps={{ variant: 'body2' }}
                    className={classes.listItemText}
                  />
                  <span className={classes.arrow}>►</span>
                </ListItem>
              );
            })}
          </List>
        </Drawer>
      </MuiThemeProvider>
    );
  }
}
